import { render, staticRenderFns } from "./UClub.vue?vue&type=template&id=251ae496&scoped=true&"
import script from "./UClub.vue?vue&type=script&lang=js&"
export * from "./UClub.vue?vue&type=script&lang=js&"
import style0 from "./UClub.vue?vue&type=style&index=0&id=251ae496&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251ae496",
  null
  
)

export default component.exports